export default {
  contact: 'Contact Us',
  emailTitle: 'Send us an email',
  emailSubTitle: 'Get in touch with your Merchant Support Analyst',
  subject: 'Subject',
  message: 'Your message',
  btn: 'Send Message',
};
